import React from 'react'
import FlipMove from 'react-flip-move'
import PropTypes from 'prop-types'
import { Box, Grid } from '@material-ui/core'
import clsx from 'clsx'
import EditableHTML from '@v4/components/common/EditableHTML'
import Image from '@v4/components/common/Image'
import SortHandler from '@v4/components/common/SortHandler'
import PageMetaData from '@v4/utils/data/PageMetaData'
import EditableContainer from '@v4/components/common/EditableContainer'
import Item from './components/Item'
import { useCategory4 } from './Category4.hooks'

const Category4 = props => {
	const [
		{
			classes,
			direction,
			withImage,
			image,
			withBgImage,
			items,
			mobileAlignment,

			title,
			titleKey,
			titleConfig,
			titleEditable,

			text,
			textKey,
			textConfig,
			textEditable,
		},
		{ handleTitleClick, handleTitleChange, handleTextChange, handleTextClick, handleImageClick },
	] = useCategory4(props)

	return (
		<>
			{withBgImage && (
				<Image
					className={clsx(classes.background, 'category4-bg-image')}
					metaData={image}
					isBackground
					onClick={handleImageClick}
				/>
			)}
			<Grid container alignItems="center" className="category4">
				<SortHandler direction={direction}>
					<Grid item lg={5} md={5} sm={12} xs={12} className="category4-image-container">
						{withImage && (
							<Image
								className={clsx(classes.image, 'category4-image')}
								metaData={image}
								onClick={handleImageClick}
							/>
						)}
					</Grid>
					<Grid item lg={1} md={1} />
					<Grid item lg={6} md={6} sm={12} xs={12} className="category4-content">
						{(title || text) && (
							<Box>
								<EditableContainer
									visible={!!title}
									fieldConfig={titleConfig}
									onAdd={handleTitleChange}
									editable={titleEditable}
									white={withBgImage}
								>
									<EditableHTML
										key={titleKey}
										className={clsx(classes.title, 'category4-text-block-title')}
										gutterBottom
										align="left"
										html={title}
										onClick={handleTitleClick}
										editable={titleEditable}
										onChange={handleTitleChange}
										white={withBgImage}
									/>
								</EditableContainer>
								<EditableContainer
									visible={!!text}
									fieldConfig={textConfig}
									onAdd={handleTextChange}
									editable={textEditable}
									white={withBgImage}
								>
									<EditableHTML
										key={textKey}
										className={clsx(classes.description, 'category4-text-block-description')}
										align="left"
										html={text}
										editable={textEditable}
										onClick={handleTextClick}
										onChange={handleTextChange}
										white={withBgImage}
									/>
								</EditableContainer>
							</Box>
						)}
						<Grid container spacing={3} className="category4-items">
							<FlipMove duration={300} typeName={null}>
								{_.map(items, (key, index) => (
									<Grid item key={key} lg={4} md={4} sm={4} xs={6} className="category4-item">
										<Item
											key={key}
											group="items"
											itemKey={key}
											index={index}
											white={withBgImage}
											mobileAlignment={mobileAlignment}
										/>
									</Grid>
								))}
							</FlipMove>
						</Grid>
					</Grid>
				</SortHandler>
			</Grid>
		</>
	)
}

Category4.propTypes = {
	metaData: PropTypes.shape({
		items: PropTypes.instanceOf(PageMetaData),
		title: PropTypes.instanceOf(PageMetaData),
		image: PropTypes.instanceOf(PageMetaData),
		text: PropTypes.instanceOf(PageMetaData),
		imagePosition: PropTypes.instanceOf(PageMetaData),
		mobileAlignment: PropTypes.instanceOf(PageMetaData),
		mobileImage: PropTypes.instanceOf(PageMetaData),
		mobileImagePosition: PropTypes.instanceOf(PageMetaData),
		opacity: PropTypes.instanceOf(PageMetaData),
		overrideXsMargins: PropTypes.instanceOf(PageMetaData),
		xsMarginTop: PropTypes.instanceOf(PageMetaData),
		xsMarginBottom: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default Category4
